import React from "react";
import "./Navbar.css";
import { navLinks } from "../../data/content";
import logo from "../../assets/images/logo.png";
import playIcon from "../../assets/icons/play.svg";
import pauseIcon from "../../assets/icons/pause.svg";

const Navbar = ({ isPlaying, onToggleMusic }) => {
  return (
    <header className="nav-wrap">
      <nav className="nav">

        <a className="nav-logo" href="#introduction">
          <img src={logo} alt="Fairuz Logo" />
        </a>

        <ul className="nav-links">
          {navLinks.map((item) => (
            <li key={item.id}>
              <a href={`#${item.id}`} className="nav-link">
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className="nav-music"
          onClick={onToggleMusic}
        >
          <img
            src={isPlaying ? pauseIcon : playIcon}
            className="nav-music-icon"
            alt=""
          />
        </button>

      </nav>
    </header>
  );
};

export default Navbar;